// conjugation.js

/**
 * Спряження для "місяць"
 * @param {number} months
 * @param {Function} t - i18n translate function
 */

// TODO: After migrating all components where this is used, you will need to remove the “t” parameter - and use t = useI18n() instead, inside this helper

export const conjugationMonth = (months, t) => {
    if (months === 1) return `${months} ${t('page.tariffs.value_months[0]')}`
    if (months < 5) return `${months} ${t('page.tariffs.value_months[1]')}`
    return `${months} ${t('page.tariffs.value_months[2]')}`
}

/**
 * Спряження для "номер"
 * @param {number} numbers
 * @param {Function} t - i18n translate function
 */
export const conjugationNumber = (numbers, t) => {
    if (numbers === 1) return `${numbers} ${t('page.tariffs.value_numbers[0]')}`
    if (numbers < 5) return `${numbers} ${t('page.tariffs.value_numbers[1]')}`
    return `${numbers} ${t('page.tariffs.value_numbers[2]')}`
}
